document.addEventListener("DOMContentLoaded", function () {
  function toggleFooterDropdown() {
    // Select all headings
    const allHeadings = document.querySelectorAll("footer .footer-block__heading");

    // Filter out those inside .footer-block__brand-info
    const headings = Array.from(allHeadings).filter(
      (heading) => !heading.closest(".footer-block__brand-info")
    );

    if (window.innerWidth < 749) {
      headings.forEach((heading) => {
        heading.removeEventListener("click", handleClick);
        heading.addEventListener("click", handleClick);
      });
    } else {
      // Expand all dropdowns and remove event listeners
      document.querySelectorAll("footer .footer-block__details-content").forEach((content) => {
        content.style.display = "block";
      });

      headings.forEach((heading) => {
        heading.removeEventListener("click", handleClick);
      });
    }
  }

  function handleClick() {
    const content = this.nextElementSibling;
    if (content) {
      content.style.display = content.style.display === "block" ? "none" : "block";
    }
    this.classList.toggle("active"); // Optional styling toggle
  }

  toggleFooterDropdown(); // Run on load
  window.addEventListener("resize", toggleFooterDropdown); // Run on resize
});
